<template>
  <div class="customer-orders">
    <loading-panel :loading="loading">
      <div class="text-center mb-3">
        <router-link to="/customer-orders">Back to Orders</router-link>
      </div>
      <h2 class="text-center">Order Details</h2>
      <div v-if="order" class="m-auto">
        <div class="handled-div text-center">
          <loading-panel :loading="loadingEdit">
            <span class="mr-3">
              Handled:
              <i :class="`fa ${ order.handled ? 'fa-check' : 'fa-times'}`"></i>
            </span>
            <button
              class="small-btn btn"
              v-if="!order.handled"
              @click="handle(true)"
            >Mark as Handled</button>
            <button class="small-btn btn" v-else @click="handle(false)">Mark as Not-Handled</button>
          </loading-panel>
        </div>
        <hr />

        <table class="table table-striped table-thick m-auto w-100">
          <thead>
            <tr>
              <th>User</th>
              <th>Date Placed</th>
              <th>Confirmation #</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ order.user ? `${order.user.firstName} ${order.user.lastName}` : '&lt;not set&gt;' }}</td>
              <td>{{ new Date(order.createdAt).toLocaleString() }}</td>
              <td>{{ $consts.ORDER_NUM_BASE + order.id }}</td>
              <td>${{ order.price.toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <hr />

        <table class="table table-striped table-thick m-auto w-100">
          <thead>
            <tr>
              <th>Line Item</th>
              <th>Quantity</th>
              <th>Price per Unit ($)</th>
              <th>Total Price ($)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(option, i) in order.checkout_option_responses"
              :key="`line-item-${i}`"
              :set="applicableCount = getApplicableNodeCount(option)"
            >
              <!-- Item name -->
              <td>{{option.checkout_option.label}}</td>
              <!-- Item count -->
              <td v-if="!option.nodeTypesJsonSnapshot">
                <!-- if the option is not per-node in nature, it's count is 1 -->
                x1
              </td>
              <td v-else>x{{applicableCount}}</td>

              <td>{{option.priceSnapshot.toFixed(2)}}</td>

              <td>{{(option.priceSnapshot * (applicableCount)).toFixed(2)}}</td>
            </tr>
          </tbody>
        </table>

        <hr />
        <h4>Nodes</h4>
        <table class="table table-striped m-auto w-100">
          <thead>
            <tr>
              <th style="width: 50%">Title</th>
              <th>Type</th>
              <th class="text-center">Label</th>
              <th class="text-center">Schedule</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(node, i) in nodes" :key="`types-${i}`">
              <td>{{ node.title }}</td>
              <td>{{ $consts.NODE_LABELS_FOR_INT_TYPE[node.node.type] }}</td>
              <td class="text-center">
                <loading-panel :loading="node.labelLoading">
                  <button class="btn small-btn" @click="onDownloadLabel(node)">
                    <i v-if="node.labelDownloaded" class="fa fa-check"></i>
                    <i v-else class="fa fa-download"></i>
                  </button>
                </loading-panel>
              </td>
              <td class="text-center">
                <loading-panel
                  :loading="node.scheduleLoading"
                  v-if="node.node.type == $consts.PANEL || node.node.type == $consts.DISTRIBUTION_PANELBOARD"
                >
                  <button class="btn small-btn" @click="onDownloadSchedule(node)">
                    <i v-if="node.scheduleDownloaded" class="fa fa-check"></i>
                    <i v-else class="fa fa-download"></i>
                  </button>
                </loading-panel>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <error-panel class="m-auto" :errors="errors"></error-panel>
    </loading-panel>
  </div>
</template>

<script>
export default {
  name: "companies",
  components: {},
  data: () => ({
    loading: false,
    loadingEdit: false,
    order: null,
    nodes: [],
    errors: []
  }),
  methods: {
    async handle(handled) {
      try {
        this.loadingEdit = true;
        await this.$web.setOrderHandled(this.order.id, handled);
        this.order.handled = handled;
      } catch (e) {
        console.log("Error: ", e);
        alert("Failed to mark this order as handled.");
      } finally {
        this.loadingEdit = false;
      }
    },
    async onDownloadLabel(node) {
      try {
        node.labelLoading = true;
        this.$forceUpdate();
        var response = await this.$web.displayLabel(node.node.id);
        this.$utils.downloadBlob(
          new Blob([response.data]),
          `Label - ${node.title}.pdf`
        );
        node.labelDownloaded = true;
      } catch (e) {
        let error = await this.$utils.getNodeError(e);
        if (error) {
          alert(error);
        } else {
          alert("Download failed.");
        }
      } finally {
        node.labelLoading = false;
        this.$forceUpdate();
      }
    },
    async onDownloadSchedule(node) {
      try {
        node.scheduleLoading = true;
        this.$forceUpdate();
        var response = await this.$web.displaySchedule(node.node.id);
        this.$utils.downloadBlob(
          new Blob([response.data]),
          `Schedule - ${node.title}.pdf`
        );
        node.scheduleDownloaded = true;
      } catch (e) {
        let error = await this.$utils.getNodeError(e);
        if (error) {
          alert(error);
        } else {
          alert("Download failed.");
        }
      } finally {
        node.scheduleLoading = false;
        this.$forceUpdate();
      }
    },
    getNodesForType(typeString) {
      return this.nodes.filter(
        node => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT[typeString]
      );
    },
    getApplicableNodeCount(option) {
      let applicableNodeTypes = JSON.parse(option.nodeTypesJsonSnapshot);
      if (!applicableNodeTypes) {
        return 1;
      }

      let total = 0;
      applicableNodeTypes.forEach(type => {
        total += this.nodes.filter(node => node.node.type == type).length;
      });

      return total;
    }
  },
  computed: {
    orderId() {
      return this.$route.params.orderId;
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getCustomerOrder(this.orderId);
      this.order = response.data.order;
      this.nodes = response.data.nodes;
      this.nodes.forEach(node => {
        node.labelLoading = false;
        node.labelDownloaded = false;

        node.scheduleLoading = false;
        node.scheduleDownloaded = false;
      });

      // Sort nodes by OUTER_SORT: node type, INNER_SORT: title
      this.nodes.sort(
        (a, b) => a.title[0].toLowerCase() > b.title[0].toLowerCase()
      );
      this.nodes.sort((a, b) => a.node.type - b.node.type);
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.customer-orders {
  padding: 20px;
  max-width: 768px;
  margin: auto;
}

h3 {
  text-align: center;
}
</style>
